export const FeatureFlags = {
  TEST_REGISTERED_TOKEN: 'test-registered-token',
  ORGANIZATIONS_ID: 'organizations-id',
  SUPPORT_ROLE_ACCESS: 'support-role-access',
  SUB_ORGANIZATION_RENAME: 'sub-organization-rename',
  LICENSE_DISTRIBUTION: 'ap-license-distribution',
  CREATE_SUB_ORGANIZATION: 'ap-create-sub-organization',
  ENABLE_MOVE_ADD_NEW_USER: 'ap-enable-move-add-new-user',
  ENABLE_MOVE_ADD_MULTIPLE_USERS: 'ap-enable-move-add-multiple-users',
} as const
